<div class='container'>
    <div *ngIf='showLoading' class='mask'>
        <i class='spinner'></i>
        <h2>{{call.description}}</h2>
    </div>
</div>
